import { ERROR_CODE } from '@config/errors';
import { findByCode } from '@helpers/data';
import { AppFCC, PAY_MODE } from '@types';
import { PaymentAggregatorIframeWidget } from '@widgets/payments/payment-aggregator-iframe';
import { PaymentAggregatorTabWidget } from '@widgets/payments/payment-aggregator-tab';
import { PaymentAggregatorWindowWidget } from '@widgets/payments/payment-aggregator-window';
import { ERRORS_PANE_BG_COLOR, ErrorsPane } from '@kit/errors/errors-pane';
import { LoadingOverlay } from '@kit/loading-overlay';
import { PaymentAggregatorWidgetAggregatorErrorStyled, PaymentAggregatorWidgetStyled } from './styled';
import { PaymentAggregatorWidgetProps } from './types';

/**
 * Depending on a payment type the widget has to render:
 * a payment aggregator iframe;
 * a link to payment page;
 * a form with hidden fields and a button that submits the form.
 */
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const PaymentAggregatorWidget: AppFCC<PaymentAggregatorWidgetProps> = props => {
  const {
    payModeClassName,
    payMode,
    payData,
    payButtonOnClick,
    errors,
    pending,
    onError
  } = props;
  if (errors && findByCode(errors, ERROR_CODE.PAYMENT_AGGREGATOR_MIR_ERROR)) {
    return _jsx(PaymentAggregatorWidgetAggregatorErrorStyled, {
      children: "\u041F\u043E \u043E\u043F\u043B\u0430\u0442\u0430\u043C \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u044B. \u041E\u043F\u043B\u0430\u0442\u044B \u0432\u043E\u0437\u043E\u0431\u043D\u043E\u0432\u044F\u0442\u0441\u044F \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F."
    });
  }
  return _jsxs(PaymentAggregatorWidgetStyled, {
    children: [payMode === PAY_MODE.FRAME ? _jsx(PaymentAggregatorIframeWidget //
    , {
      payFrameData: !payData || payData.mode !== PAY_MODE.FRAME //
      ? undefined : payData.frame,
      pending: pending,
      onError: onError
    }) : payMode === PAY_MODE.TAB ? _jsx(PaymentAggregatorTabWidget, {
      className: payModeClassName,
      payData: !payData || payData.mode !== PAY_MODE.TAB //
      ? undefined : payData.tab,
      pending: pending,
      payButtonOnClick: payButtonOnClick
    }) : payMode === PAY_MODE.WINDOW ? _jsx(PaymentAggregatorWindowWidget, {
      className: payModeClassName,
      payData: !payData || payData.mode !== PAY_MODE.WINDOW //
      ? undefined : payData.window,
      pending: pending,
      payButtonOnClick: payButtonOnClick
    }) : pending ? _jsx(LoadingOverlay, {}) : null, _jsx(ErrorsPane //
    , {
      errors: errors,
      bgColor: ERRORS_PANE_BG_COLOR.RED
    })]
  });
};